import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PoliciesPage as RulesInner } from "./Policies";
import { PacksPage as PacksInner } from "./Packs";

type Tab = "rules" | "packs";

/** Merged Policies page. Exposes Rules and Packs as inline sub-tabs so there
 *  is a single "Policies" entry in the sidebar. URL-driven — ?tab=packs works
 *  for direct-links and preserves the /policies/packs route that existed
 *  before the merge. */
export function PoliciesShell() {
  const location = useLocation();
  const navigate = useNavigate();

  const initial: Tab = location.pathname.endsWith("/packs") || location.search.includes("tab=packs") ? "packs" : "rules";
  const [tab, setTab] = useState<Tab>(initial);

  function switchTab(next: Tab) {
    setTab(next);
    const base = "/policies";
    // Keep the URL in sync so back/forward and bookmarks still work.
    navigate(next === "packs" ? `${base}?tab=packs` : base, { replace: true });
  }

  return (
    <>
      <div className="sg-subnav">
        <button
          type="button"
          className={`sg-subnav-item${tab === "rules" ? " active" : ""}`}
          onClick={() => switchTab("rules")}
        >
          Rules
        </button>
        <button
          type="button"
          className={`sg-subnav-item${tab === "packs" ? " active" : ""}`}
          onClick={() => switchTab("packs")}
        >
          Packs
        </button>
      </div>
      {tab === "rules" ? <RulesInner /> : <PacksInner />}
    </>
  );
}
